import { connect } from "react-redux";

import {
    combineMultipleFufWithTransferType,
    excelsToPartialFufsAction,
    importXmlsAction,
    UploadedFileInfo,
    uploadFileAction,
    uploadFufFileAction,
} from "../../../../ActionCreators/FufUploadActionCreator";
import { CandyDispatch } from "../../../Store/CandyReduxTypes";
import { CustomFile } from "../../../../../Helpers/file";
import { FullFormState } from "../../../Store/FullFormState";
import {
    CombinatorType,
    CombineFufResult,
    FufCombineMethod,
} from "../../../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";
import { ICombineByTransfers } from "../UploadSection/Types";
import { ServerErrorResponse } from "../../../../../../../Common/CandyApiClient/Types/DraftActions/FileProperties";

import { UploadExcelInTableModal } from "./UploadExcelInTable";

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
    modalSettings: state.modalState,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    importXmls: (
        driveUris: string[],
        combineMethod: FufCombineMethod,
        combinatorType: CombinatorType,
        isImportByFuf: boolean,
        args?: string[]
    ): Promise<CombineFufResult | undefined> =>
        dispatch(importXmlsAction(driveUris, combineMethod, combinatorType, isImportByFuf, args)),
    excelsToPartialFufs: (gfv: string, pathToTable: string, driveUris: string[]) =>
        dispatch(excelsToPartialFufsAction(gfv, pathToTable, driveUris)),
    uploadFile: (): Promise<CustomFile | undefined> => dispatch(uploadFileAction),
    reload: async () =>
        dispatch(async (_, __, form): Promise<void> => {
            await form.reloadInner();
        }),
    combineMultipleWithTransfer: (
        files: ICombineByTransfers[],
        abortSignal?: AbortSignal
    ): Promise<ServerErrorResponse | undefined> => dispatch(combineMultipleFufWithTransferType(files, abortSignal)),
    getFileProperties: (
        file: CustomFile | undefined,
        ignoreSizeCheck?: boolean,
        skipUploadFile?: boolean
    ): Promise<UploadedFileInfo> => dispatch(uploadFufFileAction(file, ignoreSizeCheck, skipUploadFile)),
});

export const UploadExcelInTableModalContainer = connect(mapStateToProps, mapDispatchToProps)(UploadExcelInTableModal);
